// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Ea1fn","rotate":"classes_rotate__2jLf4"};